<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="6">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisibleUnit()"
                                @blur="toggleCloseVisibleUnit()"
                                v-model="queryUnit"
                                v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                                @keydown.up="upUnit"
                                @keydown.down="downUnit"
                                @keydown.enter="selectItemUnit"
                                placeholder="Pilih Unit"
                        >
                        <div class="popovers" v-show="visibleUnit">
                            <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesUnit"
                                    :key="index"
                                    :class="{ 'selected': (selectedUnit == index)}"
                                    @click="itemClickedUnit(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="4">
                    <input 
                        class="form-control" 
                        v-model="tanggal"
                        type="date"
                    />
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Unit Level</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    v-if="statusBidang == true"
                                    style="background-color:whitesmoke"
                                    disabled
                                    v-model="queryUnitLevel"
                                    v-text="selectedItemUnitLevel ? selectedItemUnitLevel['text'] : ''"
                                    @keydown.up="upUnitLevel"
                                    @keydown.down="downUnitLevel"
                                    @keydown.enter="selectItemUnitLevel"
                                    placeholder="Pilih Unit Level"
                            >
                            <input type="text"
                                    class="form-control"
                                    v-else
                                    @click="toggleVisibleUnitLevel()"
                                    @blur="toggleCloseVisibleUnitLevel()"
                                    :class="{ 'is-invalid':$v.queryUnitLevel.$error, 'is-valid': !$v.queryUnitLevel.$invalid }"
                                    v-model.trim="$v.queryUnitLevel.$model"
                                    v-text="selectedItemUnitLevel ? selectedItemUnitLevel['text'] : ''"
                                    @keydown.up="upUnitLevel"
                                    @keydown.down="downUnitLevel"
                                    @keydown.enter="selectItemUnitLevel"
                                    placeholder="Pilih Unit Level"
                            >
                            <div class="popovers" v-show="visibleUnitLevel">
                                <div class="options" v-if="matchesUnitLevel.length != 0 && queryUnitLevel.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesUnitLevel"
                                        :key="index"
                                        :class="{ 'selected': (selectedUnitLevel == index)}"
                                        @click="itemClickedUnitLevel(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesUnitLevel.length == 0 && queryUnitLevel.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesUnitLevel.length == 0 && queryUnitLevel.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                        <div>
                            <input type="checkbox" v-model="allBidang" id="allBidang" @change="checkBidang()">
                            <label :for="allBidang" class="ml-2" style="color:black">Semua Bidang</label>
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tanggalAdd.$model"
                            :class="{ 'is-invalid':$v.tanggalAdd.$error, 'is-valid': !$v.tanggalAdd.$invalid }"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Status</label>
                        <model-select :options="dataLibur"
                            class="form-control model-select"
                            v-model.trim="$v.libur.$model"
                            :class="{ 'is-invalid select-invalid':$v.libur.$error, 'is-valid select-valid': !$v.libur.$invalid }"
                            placeholder="Pilih Status">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Hari Raya</label>
                        <model-select :options="dataRaya"
                            class="form-control model-select"
                            v-model.trim="$v.raya.$model"
                            :class="{ 'is-invalid select-invalid':$v.raya.$error, 'is-valid select-valid': !$v.raya.$invalid }"
                            placeholder="Pilih Hari Raya">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow class="mt-2 mb-3">
                    <CCol sm="6">
                        <label>Keterangan</label>
                        <textarea 
                            class="form-control" 
                            placeholder="Keterangan"
                            v-model.trim="$v.keterangan.$model"
                            :class="{ 'is-invalid':$v.keterangan.$error, 'is-valid': !$v.keterangan.$invalid }"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableHoliday'
import {DataApi} from "../../../service/DataApi";
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { ModelSelect } from 'vue-search-select'
import { validationMixin } from 'vuelidate'
export default {
    components: {
        Tables,
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        queryUnitLevel: {
            required
        },
        tanggalAdd: {
            required
        },
        libur: {
            text: {
                required
            },
            value: {
                required
            }
        },
        raya: {
            text: {
                required
            },
            value: {
                required
            }
        },
        keterangan: {
            required
        }
    },
    data() {
        return {
            success: true,
            itemHeight: 39,

            // data search select unit
            dataUnit: [],
            titleUnit:"Pilih Unit",
            selectedItemUnit: null,
            selectedUnit: 0,
            queryUnit: '',
            visibleUnit: false,
            idUnit: '',

            // data search select unit
            dataUnitLevel: [],
            titleUnitLevel:"Pilih UnitLevel",
            selectedItemUnitLevel: null,
            selectedUnitLevel: 0,
            queryUnitLevel: '',
            visibleUnitLevel: false,
            idUnitLevel: '',

            backIcon: require('../../../assets/menu/icon_goback.svg'),
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Tanggal', 'Hari', 'Hari Libur', 'Action'],
            dataTd: ['tanggal', 'hari', 'keterangan', 'action'],
            styleTable: ['100px', '100px', '400px', '100px'],
            classReload: 'reloadOff',

            // pagination
            page: 1,
            size: 100,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,
            
            // datas
            datas: [],
            libur: {
                value: '',
                text: ''
            },
            dataLibur: [],
            raya: {
                value: '',
                text: ''
            },
            dataRaya: [],
            tanggal: '',
            tanggalAdd: '',
            unix: '',
            tipe: 'C',
            keterangan: '',
            allBidang: false,
            statusBidang: false,

            //error
            errorMessage: '',
            flagSearch: false
        }
    },
    computed: {
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        },
        matchesUnitLevel() {
            if (this.queryUnitLevel == '') {
                return [];
            }
            return this.dataUnitLevel.filter((item) => item['text'].toLowerCase().includes(this.queryUnitLevel.toLowerCase()))
        },
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryUnit() {
            if(this.queryUnit == '') {
                this.idUnit = ''
            }
            this.flagSearch = true
            this.getDataUnit()
        },
        tanggal() {
            this.flagSearch = true
        },
        queryUnitLevel() {
            if(this.queryUnitLevel == '') {
                this.idUnitLevel = ''
            }
            this.getDataUnitLevel('null')
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    methods: {
        checkBidang() {
            if(this.allBidang == true) {
                this.statusBidang = true
                this.queryUnitLevel = ''
                this.idUnitLevel = ''
            } else {
                this.statusBidang = false
            }
        },
        /**
         * SEARCH SELECT UNIT
         */
        getDataUnit() {
            let payload = {
                limit: 10,
                namaUnit: this.queryUnit,
                pageIn: 1,
                namaParentUnit: '',
                idUnit: ''
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnit = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].id,
                        text: tempData[i].bidang
                    }
                    this.dataUnit.push(onPush)
                }
            })
        },

        toggleVisibleUnit() {
            this.visibleUnit = true;
        },
        hideUnit() {
            this.visibleUnit = false;
        },
        toggleCloseVisibleUnit() {
            setTimeout(this.hideUnit, 1000);
        },
        itemClickedUnit(index) {
            this.selectedUnit = index;
            this.selectItemUnit();
        },
        selectItemUnit() {
            if (!this.matchesUnit.length) {
            return;
            }
            this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
            this.visibleUnit = false;
            this.queryUnit = this.selectedItemUnit.text
            this.idUnit = this.selectedItemUnit.value
            if (this.shouldReset) {
            this.queryUnit = '';
            this.selectedUnit = 0;
            }
        },
        upUnit() {
            if (this.selectedUnit == 0) {
            return;
            }
            this.selectedUnit -= 1;
            this.scrollToItemUnit();
        },
        downUnit() {
            if (this.selectedUnit >= this.matchesUnit.length - 1) {
            return;
            }
            this.selectedUnit += 1;
            this.scrollToItemUnit();
        },
        scrollToItemUnit() {
            this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
        },

        /**
         * SEARCH SELECT UNIT LEVEL
         */
        getDataUnitLevel(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    limit: 10,
                    namaUnit: this.queryUnitLevel,
                    pageIn: 1,
                    namaParentUnit: '',
                    idUnit: ''
                }
            } else {
                payload = {
                    limit: 10,
                    namaUnit: '',
                    pageIn: 1,
                    namaParentUnit: '',
                    idUnit: val
                }
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnitLevel = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].id,
                        text: tempData[i].bidang
                    }
                    this.dataUnitLevel.push(onPush)
                }
                if(val != 'null') {
                    this.queryUnitLevel = this.dataUnitLevel[0].text
                    this.idUnitLevel = val
                }
            })
        },

        toggleVisibleUnitLevel() {
            this.visibleUnitLevel = true;
        },
        hideUnitLevel() {
            this.visibleUnitLevel = false;
        },
        toggleCloseVisibleUnitLevel() {
            setTimeout(this.hideUnitLevel, 1000);
        },
        itemClickedUnitLevel(index) {
            this.selectedUnitLevel = index;
            this.selectItemUnitLevel();
        },
        selectItemUnitLevel() {
            if (!this.matchesUnitLevel.length) {
            return;
            }
            this.selectedItemUnitLevel = this.matchesUnitLevel[this.selectedUnitLevel];
            this.visibleUnitLevel = false;
            this.queryUnitLevel = this.selectedItemUnitLevel.text
            this.idUnitLevel = this.selectedItemUnitLevel.value
            if (this.shouldReset) {
            this.queryUnitLevel = '';
            this.selectedUnitLevel = 0;
            }
        },
        upUnitLevel() {
            if (this.selectedUnitLevel == 0) {
            return;
            }
            this.selectedUnitLevel -= 1;
            this.scrollToItemUnitLevel();
        },
        downUnitLevel() {
            if (this.selectedUnitLevel >= this.matchesUnitLevel.length - 1) {
            return;
            }
            this.selectedUnitLevel += 1;
            this.scrollToItemUnitLevel();
        },
        scrollToItemUnitLevel() {
            this.$refs.optionsList.scrollTop = this.selectedUnitLevel * this.itemHeight;
        },


        
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.tanggal.toLowerCase() < b.tanggal.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggal.toLowerCase() > b.tanggal.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.hari.toLowerCase() < b.hari.toLowerCase()) {
                        return -1
                    }
                    if (a.hari.toLowerCase() > b.hari.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
                        return -1
                    }
                    if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let tanggal = this.tanggal
            let page = this.page
            let level = this.idUnit

            let payload = {
                level: level,
                limit: limit,
                tanggal: tanggal,
                pageIn: page,
            }
            DataApi.post("kalender/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        getDataLlibur() {
            this.dataLibur = [
                {
                    text: 'Hari Libur',
                    value: 'Y'
                },
                {
                    text: 'Bukan Hari Libur',
                    value: 'N'
                }
            ]
        },
        getDataRaya() {
            this.dataRaya = [
                {
                    text: 'Hari Raya Keagamaan',
                    value: 'Y'
                },
                {
                    text: 'Bukan Hari Raya Keagamaan / Hari Libur Pemerintah / Hari Peringatan',
                    value: 'N'
                },
                {
                    text: 'Cuti Bersama',
                    value: 'C'
                }
            ]
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.tanggal = ''
            this.queryUnit = ''
            this.idUnit = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        findData() {
            this.getData()
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.unix = ''
                this.tanggalAdd = ''
                this.keterangan = ''
                this.libur.value = ''
                this.libur.text = ''
                this.raya.value = ''
                this.raya.text = ''
                this.queryUnitLevel = ''
                this.idUnitLevel = ''
                this.queryUnit = ''
                this.idUnit = ''
                this.allBidang = false
                this.statusBidang = false
                this.tipe = 'c'
                this.getDataLlibur()
                this.getDataRaya()
                this.getDataUnit()
                this.getDataUnitLevel('null')
                this.$v.$reset()
            }
        },
        goSave() {
            let keterangan = this.keterangan
            let level = ''
            if(this.allBidang == true) {
                level = ''
            } else {
                level = this.idUnitLevel
            }
            let libur = this.libur.value
            let raya = this.raya.value
            let tanggal = this.tanggalAdd
            let unix = this.unix
            let tipe = this.tipe

            let payload ={
                keterangan: keterangan,
                level: level,
                libur: libur,
                hariRaya: raya,
                tanggal: tanggal,
                unix: unix,
                tipe: tipe
            }
            DataApi.post("kalender/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.keterangan = generate.keterangan
            this.tanggalAdd = generate.tanggal
            this.unix = generate.unix

            let dataLibur = this.dataLibur
            let libur = generate.libur
            var i = 0
            for(i=0;i<dataLibur.length;i++) {
                if(libur == dataLibur[i].value) {
                    this.libur.value = dataLibur[i].value
                    this.libur.text = dataLibur[i].text
                }
            }
            let dataRaya = this.dataRaya
            let raya = generate.hariRaya
            var j = 0
            for(j=0;j<dataRaya.length;j++) {
                if(raya == dataRaya[j].value) {
                    this.raya.value = dataRaya[j].value
                    this.raya.text = dataRaya[j].text
                }
            }
            if(generate.level != 'null') {
                this.getDataUnitLevel(generate.level)
            } else {
                this.queryUnitLevel = ''
                this.idUnitLevel = ''
                this.allBidang = true
                this.statusBidang = true
            }
            this.tipe = 'u'
            this.moving()
        },

        /**
         * VALIDATION DATA
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.$v.queryUnitLevel.$invalid && this.allBidang == true) {
                    this.goSave()
                    this.loading = true
                }
            } else {
                this.goSave()
                this.loading = true
            }
        },

    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataUnit()
        this.getDataUnitLevel('null')
        this.getDataLlibur()
        this.getDataRaya()
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.alert-area {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: rgb(77, 221, 48);
    text-align: center;
    color: white;
    font-size: 14px;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>